import { CubeSideName, CubeSidesIntersectionsMap } from "./types";

export const CUBE_SIDES_INTERSECTIONS: CubeSidesIntersectionsMap = {
  1: [
    { side: "5", intersection: 3 },
    { side: "6", intersection: 4 },
    { side: "3", intersection: 1 },
    { side: "4", intersection: 2 },
  ],
  2: [
    { side: "6", intersection: 8 },
    { side: "3", intersection: 5 },
    { side: "4", intersection: 6 },
    { side: "5", intersection: 7 },
  ],
  3: [
    { side: "2", intersection: 5 },
    { side: "6", intersection: 12 },
    { side: "1", intersection: 1 },
    { side: "4", intersection: 9 },
  ],
  4: [
    { side: "2", intersection: 6 },
    { side: "3", intersection: 9 },
    { side: "1", intersection: 2 },
    { side: "5", intersection: 10 },
  ],
  5: [
    { side: "2", intersection: 7 },
    { side: "4", intersection: 10 },
    { side: "1", intersection: 3 },
    { side: "6", intersection: 11 },
  ],
  6: [
    { side: "2", intersection: 8 },
    { side: "5", intersection: 11 },
    { side: "1", intersection: 4 },
    { side: "3", intersection: 12 },
  ],
};

export const CUBE_SIDE_NAMES: CubeSideName[] = ["5", "1", "6", "3", "4", "2"];
export const COLLAPSED_CUBE_SIDE_NAMES: CubeSideName[] = ["3", "4", "2"];

export const CUBE_SIDE_NUMBER_TO_NAME: Partial<Record<CubeSideName, string>> = {
  "2": "organization",
  "3": "leadership",
  "4": "team",
};

export const CUBE_SIDE_NAME_TO_NUMBER: Record<string, string> = {
  organization: "2",
  leadership: "3",
  team: "4",
};

/*Only as reference for old names, can be deleted later*/
export const CUBE_SIDE_NUMBER_TO_NAME_MAP_OLD: Record<number, string> = {
  1: "leader",
  2: "vision",
  3: "strategy",
  4: "kpis",
  5: "team",
  6: "structures",
};

export const CUBE_SIDE_GREY_COLOR = "#C1C1C1CC";

export const CUBE_SIDE_OUTER_BORDER_DEFAULT_COLOR = "#FFFFFF80";
export const CUBE_SIDE_OUTER_BORDER_INACTIVE_COLOR = "#FFFFFF33";
export const CUBE_SIDE_OUTER_BORDER_ACTIVE_COLOR = "#00EBC880";
export const CUBE_SIDE_OUTER_FILL_COLOR = "#FFFFFF00";
export const CUBE_SIDE_INNER_FILL_COLOR_MAX = "#FFFFFFF2";
export const CUBE_SIDE_INNER_FILL_COLOR_MIN = "#FFFFFF99";
export const CUBE_SIDE_INNER_ACTIVE_FILL_COLOR = "#00EBC8F2";
export const CUBE_SIDE_INNER_INACTIVE_FILL_COLOR = "#FFFFFF61";

export const COLLAPSED_CUBE_SIDE_STYLES: Partial<
  Record<CubeSideName, React.CSSProperties>
> = {
  "3": {
    transform:
      "translate(-27.3px, -42.5px) rotate(0deg) skewX(0deg) skewY(0deg) scaleX(0.991) scaleY(0.963)",
  },
  "4": {
    transform:
      "translate(30.7px, -40.7px) rotate(0deg) skewX(0deg) skewY(1.99deg) scaleX(0.98) scaleY(0.936)",
  },
};
